import React from "react";
import ReactApexChart from "react-apexcharts";

const Pie = ({ series, labels }) => {
  const options = {
    chart: {
      width: 480,
      type: "pie",
    },
    labels: labels,
    legend: {
      position: "bottom",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={options}
          series={series}
          type="pie"
          width={200}
          height={350}
        />
      </div>
      {/* <div id="html-dist"></div> */}
    </div>
  );
};

export default Pie;
